import { createFileRoute } from '@tanstack/react-router';
import { AssessmentLayoutComponent } from '@/app/route-components/AssessmentLayoutComponent';
import { requireFeatureFlag } from '@/entities/session/lib/featureGuard';

/**
 * 歳出比較査定レイアウトルート
 *
 * 第2メニュー（AssessmentMenu）とページコンテンツを横並びで配置する。
 * LayoutOffsetProvider で additionalLeftOffset を設定し、
 * MainPageLayout の固定ヘッダー位置を第2メニュー幅分ずらす。
 * サイドバーが hidden の場合は第2メニューも非表示になる。
 *
 * 機能フラグ `expenditure_comparison` が visible 以外（disabled / hidden）の場合は
 * URL 直アクセスを 404 で遮断する（配下の全ルートに適用される）。
 */
export const Route = createFileRoute('/_protected/assessment')({
  beforeLoad: () => {
    requireFeatureFlag('expenditure_comparison');
  },
  component: AssessmentLayoutComponent,
});
